import { useEffect, useState } from "react";
import axios from "axios";
import { Loader2, Sheet } from "lucide-react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { SheetGuide } from "@/components/admin/SheetGuide";
import { API, apiError, authHeaders } from "@/lib/api";

const Label = ({ children }) => <span className="text-xs uppercase tracking-[0.15em] text-white/60 font-medium">{children}</span>;

export const SheetPanel = () => {
  const [sheet, setSheet] = useState(null);
  const [saving, setSaving] = useState(false);
  const [testing, setTesting] = useState(false);
  const set = (k, v) => setSheet((s) => ({ ...s, [k]: v }));

  useEffect(() => {
    axios.get(`${API}/admin/sheet`, { headers: authHeaders() }).then(({ data }) => setSheet(data)).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await axios.put(`${API}/admin/sheet`, sheet, { headers: authHeaders() });
      setSheet(data);
      toast.success("Google Sheet salvato");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setSaving(false);
    }
  };

  const test = async () => {
    setTesting(true);
    try {
      await axios.post(`${API}/admin/sheet/test`, {}, { headers: authHeaders() });
      toast.success("Funziona! Nel foglio trovi una riga PROVA COLLEGAMENTO, puoi cancellarla.");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setTesting(false);
    }
  };

  if (!sheet) return null;
  return (
    <section className="glass-strong rounded-[1.5rem] p-6 md:p-8 flex flex-col gap-5 min-w-0" data-testid="admin-sheet-panel">
      <div className="flex items-center gap-3">
        <Sheet className="w-5 h-5 text-white/70" strokeWidth={1.5} />
        <h2 className="font-heading italic text-white text-3xl tracking-[-1px]">Google Sheet</h2>
      </div>
      <p className="text-xs text-white/50 leading-relaxed">Ogni prenotazione viene salvata qui sul sito e inviata anche al tuo foglio Google tramite lo script collegato.</p>
      <label className="flex items-center justify-between gap-4 cursor-pointer">
        <Label>Invio attivo</Label>
        <Switch data-testid="admin-sheet-enabled-switch" checked={sheet.enabled} onCheckedChange={(v) => set("enabled", v)} />
      </label>
      <div className="flex flex-col gap-2">
        <Label>URL Web App (Apps Script)</Label>
        <input data-testid="admin-sheet-url-input" className="glass-input text-xs" value={sheet.url} onChange={(e) => set("url", e.target.value)} placeholder="https://script.google.com/macros/s/.../exec" />
      </div>
      <div className="flex flex-col gap-2">
        <Label>Chiave segreta</Label>
        <input data-testid="admin-sheet-secret-input" className="glass-input" value={sheet.secret} onChange={(e) => set("secret", e.target.value)} placeholder="Deve combaciare con SECRET nello script" />
      </div>
      <button onClick={save} disabled={saving} data-testid="admin-save-sheet"
        className="bg-white text-black rounded-full px-6 py-3 text-sm font-medium flex items-center justify-center gap-2 hover:opacity-90 transition-opacity disabled:opacity-60">
        {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : "Salva collegamento"}
      </button>
      <button onClick={test} disabled={testing || !sheet.url} data-testid="admin-test-sheet"
        className="glass rounded-full px-6 py-3 text-sm text-white/85 hover:text-white flex items-center justify-center gap-2 disabled:opacity-40">
        {testing ? <Loader2 className="w-4 h-4 animate-spin" /> : "Prova collegamento"}
      </button>
      <SheetGuide secret={sheet.secret} />
    </section>
  );
};
